import React, { useRef, useState } from "react";
import PopUps from "./PopUps";
// import ResourceCheck from "../../components/SectionalTest/ResourceCheck";
import { Button, CardBody, Col, Row } from "react-bootstrap";
import TestHeader from "./TestHeader";
import Questions from "./Questions";
import BottomBtns from "./BottomBtns";
// import MockInfo from "./MockInfo";
import Spinner from "components/Loader/Spinner";
import LaLoader from "components/Loader/LaLoader";
// import Unfinished from "./Unfinished";
import { NavLink } from "react-router-dom";
import API from "api";
import ResourceCheck from "views/ResourceCheck";
import Unfinished from "components/SectionalTest/Unfinished";

const TestBody = ({ mockData, setMockData, routeState, soundArr, apiLoading = false }) => {
  const timerRef = useRef();
  const [questionsFunctions, setQuestionsFunctions] = useState(null);
  const [showMockInfo, setShowMockInfo] = useState(true);

  const currentQuestionRef = useRef(0);
    const extractCorrectFromHtml = (htmlString) => {
    const temp = document.createElement("div");
    temp.innerHTML = htmlString;
    const spans = temp.querySelectorAll("span#cAns");
    if (spans.length === 0) return htmlString;
    return Array.from(spans).map(span => {
      const text = span.previousSibling?.textContent || "";
      return text.trim().split(/\s+/).pop();
    });
  };
  // Fallback functions in case Questions component functions are not ready
  const fallbackFinalObjectCreation = () => {
    const actualCurrentQuestion = currentQuestionRef.current;
    let qdata = mockData.questionData[actualCurrentQuestion];
    
    let correctValue = '';
    if (mockData.correctAnswersMap && mockData.correctAnswersMap[qdata.id]) {
      correctValue = mockData.correctAnswersMap[qdata.id];
    }else if (qdata.answer && typeof qdata.answer === 'string' && qdata.answer.includes("id='cAns'")) {
      correctValue = extractCorrectFromHtml(qdata.answer);
    }
    
    return {
      type: qdata.subcategory_id,
      id: qdata.id,
      response: true,
      answer: qdata.question,
      script: qdata.audio_script,
      q_ans: qdata.answer,
      correct: correctValue
    };
  };

  const fallbackFinalSubmit = async (obj1) => {
    const actualCurrentQuestion = currentQuestionRef.current;
    let { questionData, pending } = mockData;
    let curr = questionData[actualCurrentQuestion];

    console.log("=== TIMEOUT SUBMIT ===");
    console.log("actualCurrentQuestion from ref:", actualCurrentQuestion);
    console.log("curr.question_number:", curr.question_number);
    console.log("mockData.timeOut:", mockData.timeOut);
    console.log("questionData.length:", questionData.length);
    console.log("obj1==", obj1);

    // Determine complete status
    let complete = 0;
    console.log("Checking complete conditions:");
    console.log("curr.question_number === questionData.length - 1:", curr.question_number === questionData.length - 1);
    console.log("mockData.timeOut:", mockData.timeOut);
    console.log("mockData.timeOutFlag:", mockData.timeOutFlag);
    console.log("mockData.secondCount <= 1:", mockData.secondCount <= 1);

    // For timeout scenarios, always set complete = 1
    // If this function is called and it's not the last question, it's likely a timeout
    if (curr.question_number === questionData.length - 1 || mockData.timeOut || mockData.timeOutFlag || mockData.secondCount <= 1) {
      complete = 1;
      console.log("Setting complete = 1 - normal conditions");
    } else {
      // Force complete = 1 for timeout scenarios (when timer expires)
      complete = 1;
      console.log("Setting complete = 1 - forced for timeout");
    }

    console.log("Final complete value:", complete);

    let bodyFormData = new FormData();

    if (routeState.pending === 1) {
      bodyFormData.append('result_id', routeState.id);
    }

    bodyFormData.append('q_count', questionData.length);
    bodyFormData.append('mock_id', routeState.id);
    bodyFormData.append('q_time', 0);
    bodyFormData.append('pending', 1);
    bodyFormData.append('curr_q', 0);
    bodyFormData.append('complete', complete);
    bodyFormData.append('question_number', curr.question_number);
    bodyFormData.append('time', complete === 1 ? 0 : mockData.secondCount);
    bodyFormData.append('response[]', obj1.response);
    bodyFormData.append('device', 'website');

    // Handle different question types
    if ([1, 2, 3, 4, 5, 21, 22].includes(obj1.type)) {
      bodyFormData.append('answer[]', obj1.q_ans);
      bodyFormData.append('file[]', new Blob(['hello worllllllllllllld']));
    } else if ([6, 7].includes(obj1.type)) {
      bodyFormData.append('answer[]', obj1.q_ans); 
      bodyFormData.append('file[]', new Blob(['hello worlppppppppppppd']));
    } else {
      bodyFormData.append('answer[]', obj1.q_ans);
      bodyFormData.append('file[]', new Blob(['hello worlppppppppppppd']));
    }

    bodyFormData.append('selected[]', obj1.text_answer || '');
    bodyFormData.append('text[]', obj1.answer);
    bodyFormData.append('type[]', obj1.type);
    bodyFormData.append('id[]', obj1.id);
    bodyFormData.append('duration[]', obj1.duration || 0);
    bodyFormData.append('script[]', obj1.script);
    bodyFormData.append('q_ans[]', obj1.q_ans);
    bodyFormData.append('audio_text[]', obj1.audio_text || '');
    bodyFormData.append('html[]', obj1.html || '');
    bodyFormData.append('text_answer[]', obj1.text_answer || '');
    bodyFormData.append('length[]', obj1.length || 0);
    bodyFormData.append('lang[]', obj1.lang || '');
    bodyFormData.append('correct[]', obj1.correct || '');
    bodyFormData.append('ans[]', obj1.q_ans);

    // FIXED: Return the promise chain properly
    return API({
      method: 'POST',
      url: 'submit/mock',
      data: bodyFormData
    }).then(data => {
      console.log("api hit from testbody - complete:", complete);
      console.log("API response data:", data);

      let filteredAry = mockData.ids.filter(function (e) {
        return e.id !== obj1.id;
      });
      setMockData((prevState) => {
        return {
          ...prevState,
          qTime: 0,
          ids: filteredAry,
        };
      });

      // Call submitFailed API for timeout scenarios
      setTimeout(() => {
        let formData = new FormData();

        // Build formData regardless of whether mockData.failed exists
        if (mockData.failed && mockData.failed.length > 0) {
          mockData.failed.forEach((value, index) => {
            value.forEach((val, key) => {
              if (key === 'file[]') {
                formData.append('files[]', val);
              } else {
                formData.append(`data[${index}][${key}]`, val);
              }
            });
          });
        }

        // Always call submitFailed API (moved outside the if block)
        API({
          method: 'POST',
          url: 'submitFailed/mock',
          data: formData
        }).then((res) => {
          console.log("submitFailed API called successfully:", res);
        }).catch((error) => {
          console.error("submitFailed API error:", error);
        });
      }, 2000);

      // Return the data so the promise chain continues
      return data;
    }).catch((error) => {
      console.error('Submit failed:', error);
      throw error;
    });
  };

  const showTest = () => {
    setMockData((prevState) => {
      return {
        ...prevState,
        resourceTested: true,
        secondCount: prevState.mockTime,
      };
    });
  };

  // EXTRACTED: Common test content component to avoid repetition
  const renderTestContent = () => (
    <div className="content questionsArea old-design p-0 test_width mock-container mock-resource-text" id="test-card">
      <Row>
        <Col xs={12}>
          <TestHeader
            mockData={mockData}
            setMockData={setMockData}
            id={routeState.id}
            ref={timerRef}
            finalObjectCreation={questionsFunctions?.finalObjectCreation || fallbackFinalObjectCreation}
            finalSubmit={questionsFunctions?.finalSubmit || fallbackFinalSubmit}
            routeState={routeState}
            soundArr={soundArr}
            timerRef={timerRef}
          />

          {mockData.dashboardFlag && mockData.complete === 1 ? (
            <CardBody>
              <Row className="unselectable">
                <Col>
                  You've finished this test. Click on the button to
                    <NavLink to={"/admin/mock-result"} className="text-decoration-none">
                    {" "}
                    <Button color="primary" size="xs">
                      See Results
                    </Button>{" "}
                  </NavLink>
                </Col>
              </Row>
            </CardBody>
          ) : mockData.complete === 0 && mockData.dashboardFlag ? (
            // <div className="content questionsArea mock-already-completed m-0">
            //   <Row>
            //     <Col xs={12}>
            //       <CardBody>
            //         <Row className="testFinish unselectable">
            //           <div className="col-sm-12">
            //             <p>
            //               <span>
            //                 This mock is unfinished. Please{" "}
            //                 <NavLink to={`/admin/pending`}>
            //                   <Button color="primary" size="xs">
            //                     Click here
            //                   </Button>
            //                 </NavLink>{" "}
            //                 to resume this test.
            //               </span>
            //             </p>
            //           </div>
            //         </Row>
            //       </CardBody>
            //     </Col>
            //   </Row>
            // </div>
            <Unfinished path={"pending"}/>
          ) : (
            <Questions
              mockData={mockData}
              setMockData={setMockData}
              routeState={routeState}
              soundArr={soundArr}
              timerRef={timerRef}
              onFunctionsReady={setQuestionsFunctions}
              currentQuestionRef={currentQuestionRef}
            />
          )}
        </Col>
        <BottomBtns mockData={mockData} setMockData={setMockData} />
      </Row>
    </div>
  );

  /* ==================== COMMENTED OUT: DUPLICATE CODE ====================
  // This was a duplicate of the main rendering logic - kept for reference
  const mainData = showMockInfo ? (
    <MockInfo
      setShowMockInfo={setShowMockInfo}
      categoriesData={mockData.categoriesData}
      initialTime={mockData.initialTime}
      category={mockData.mockCat}
    />
  ) : (
    <div className="content questionsArea old-design p-0 test_width" id="test-card">
      <Row>
        <Col xs={12}>
          <TestHeader
            mockData={mockData}
            setMockData={setMockData}
            id={routeState.id}
            ref={timerRef}
            finalObjectCreation={questionsFunctions?.finalObjectCreation || fallbackFinalObjectCreation}
            finalSubmit={questionsFunctions?.finalSubmit || fallbackFinalSubmit}
            routeState={routeState}
            soundArr={soundArr}
            timerRef={timerRef}
          />

          {
            mockData.dashboardFlag && mockData.complete === 1 ? (
              <>
                <CardBody>
                  <Row className="unselectable">
                    <Col>
                      You've finished this test. Click on the button to
                      <NavLink to={"/admin/results"}>
                        {" "}
                        <Button
                          color="primary" size="xs"
                        >
                          See Results
                        </Button>{" "}
                      </NavLink>
                    </Col>
                  </Row>
                </CardBody>
              </>
            ) : mockData.complete === 0 && mockData.dashboardFlag ? (
              <>
                      <div className="content questionsArea mock-already-completed m-0">
                          <Row>
                            <Col xs={12}>
                              <CardBody>
                                <Row className="testFinish unselectable">
                                  <div className="col-sm-12">
                                    <p>
                                      <span>
                                        This mock is unfinished. Please{" "}
                                        <NavLink to={`/admin/pending`}>
                                          <Button color="primary" size="xs">
                                            Click here fvs
                                          </Button>
                                        </NavLink>{" "}
                                        to resume this test.
                                      </span>
                                    </p>
                                  </div>
                                </Row>
                              </CardBody>
                            </Col>
                          </Row>
                        </div>
              </>
            ) : (
              <>
                <Questions
                  mockData={mockData}
                  setMockData={setMockData}
                  routeState={routeState}
                  soundArr={soundArr}
                  timerRef={timerRef}
                  onFunctionsReady={setQuestionsFunctions}
                  currentQuestionRef={currentQuestionRef}
                />
              </>
            )
          }
        </Col>
        <BottomBtns mockData={mockData} setMockData={setMockData} />
      </Row>
    </div>
  );
  ==================== END COMMENTED CODE ==================== */

  /* ==================== COMMENTED OUT: ANOTHER DUPLICATE RENDERING BLOCK ====================
  // This was another duplicate rendering block - kept for reference
  {
    <div className="content questionsArea old-design p-0 test_width" id="test-card">
      <Row>
        <Col xs={12}>
            <TestHeader
              mockData={mockData}
              setMockData={setMockData}
              id={routeState.id}
              ref={timerRef}
              finalObjectCreation={questionsFunctions?.finalObjectCreation || fallbackFinalObjectCreation}
              finalSubmit={questionsFunctions?.finalSubmit || fallbackFinalSubmit}
              routeState={routeState}
              soundArr={soundArr}
              timerRef={timerRef}
            />

             {
            mockData.dashboardFlag && mockData.complete == 1  ? (
              <>
              <CardBody>
                <Row className="unselectable">
                  <Col>
                    You've finished this test. Click on the button to 
                    <NavLink to={"/admin/results"}>
                     {" "}
                    <Button
                    color="primary" size="xs"
                     >
                      See Results
                     </Button>{" "}
                    </NavLink>
                   </Col>
               </Row>
             </CardBody>
              </>
            ) : mockData.complete == 0 && mockData.dashboardFlag ? (
              <>
              <Unfinished/>
              </>
            ) : (
              <>
             <Questions
              mockData={mockData}
              setMockData={setMockData}
              routeState={routeState}
              soundArr={soundArr}
              timerRef={timerRef}
                onFunctionsReady={setQuestionsFunctions}
              currentQuestionRef={currentQuestionRef}
            />
              </>
            )
           }
        </Col>
        <BottomBtns mockData={mockData} setMockData={setMockData} />
      </Row>
    </div>
  }
  ==================== END COMMENTED CODE ==================== */

  return (
    <>
      <PopUps mockData={mockData} setMockData={setMockData} />
      {!mockData.mockCat ? (
        <>
          {/* <Spinner/> */}
          <LaLoader show={!mockData.mockCat} />
        </>
      ) : apiLoading ? (
        <ResourceCheck
          showTest={showTest}
          pending={0}
          data={{}}
          cat={1}
        />
      ) : !apiLoading && mockData.mockCat && !mockData.resourceTested ? (
        <ResourceCheck
          showTest={showTest}
          pending={0}
          data={{}}
          cat={mockData.mockCat}
        />
      ) : (
        renderTestContent()
      )}
      {/* {mockData.resourceTested && mainData} */}
    </>
  );
};

export default TestBody;